const dragTypes = {
  TASK: 'task',
};

export default dragTypes;
